module.exports = __webpack_public_path__ + "img/icon_win.3ddb60fd.png";